/*
 * @Author: Eugene
 * @Date: 2020-04-13 19:58:43
 * @Last Modified by: Eugene
 * @Last Modified time: 2021-05-18 10:46:47
 */
import { message } from 'antd';
import { getPlayUrls, checkStatus } from '@/services/live/livePreview';

import moment from 'moment';

export default {
  namespace: 'livePreviewState',

  state: {},

  effects: {
    *getLiveStream({ payload }, { call, put }) {
      const { requestData, resolve } = payload;
      const res = yield call(getPlayUrls, {
        requestData,
      });

      if (res.result.code === '00000') {
        resolve(res.result.data);
      } else {
        message.error(res.result.msg, 3);
      }
    },
    *checkStatus({ payload }, { call, put }) {
      const { requestData, resolve } = payload;
      const res = yield call(checkStatus, {
        requestData,
      });

      resolve(res);
    },
  },

  reducers: {},
};
